import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SvgIconComponent } from '@woolworthsnz/styleguide';

@Component({
	selector: 'wnz-payment-direct-debit',
	template: `
		<section class="directDebit">
			<cdx-svg-icon name="direct-debit" fill="currentColor" size="small"></cdx-svg-icon>
			<p class="directDebit-title" i18n="@@directDebit-title">Direct Debit</p>
			<div>
				<ng-content select="[direct-debit-actions]"></ng-content>
			</div>
		</section>
	`,
	styleUrls: ['./payment-direct-debit.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [SvgIconComponent],
})
export class PaymentDirectDebitComponent {}
